export default "__VITE_ASSET__bRCpiuZV__"